// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__v56lU","row":"Node_row__1A2w3","label":"Node_label__gvS9R","footer":"Node_footer__22WsL"};